import QrcodeDiv from '../../shared/QrcodeDiv.js';
import StampDateConverter from '../../converter/StampDateConverter.js';
import StockinfoConverter from '../../converter/StockinfoConverter.js';
import CollapsibleDiv from '../../../components/shared/CollapsibleDiv.js';
import RemarkDiv from '../../shared/RemarkDiv.js';

function PanelRedeemInfo(props) {
    let startDate = new Date(props.data.Stamp_Start_Date);
    let endDate = new Date(props.data.Stamp_End_Date);
    let today = new Date();
    let Difference_In_Time = startDate.getTime() - today.getTime();
    let Difference_In_Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));

    const remark=()=>{
        if (props.data.Event_Url_Name === "2026032829_TSTopening" && (props.stock[0].Stock_Code === "81080066" || props.stock[0].Stock_Code === "81080070"))
        return '*3月28日(11:30-15:00)場次包括星級開幕環節: 上午11:30開放排隊，場內有福袋派發。開幕慶典於下午12:30開始(星級嘉賓:古天樂先生)，試食緊隨開幕慶典完結後開始。';
    }
    const style=()=>{
        if (props.data.Event_Url_Name === "2026032829_TSTopening")
        return {  fontWeight: 'bold', color: 'red', whiteSpace: 'pre-line' };
    }
    const shopImageUrl = process.env.REACT_APP_URL_IMAGE_COMMON+ "mainShopAddress.jpg";
    const shopImage = `<div className="pickup-logo"><img style="max-width: 100%" src='${shopImageUrl}' /></div>`;

   return (
      <>

            <div className="np-effective-info">
                <span>印花詳情 : <br></br><b>{props.stock.map((item) => <StockinfoConverter data={item}></StockinfoConverter>)}</b></span>
                <RemarkDiv className="remark" eventName={props.data.Event_Url_Name} remark={remark()} ></RemarkDiv>
            </div>   

           <div className="np-effective-info">
                
                <span>印花有效期 : </span>
                {
                    props.data.Stamp_Start_Date != props.data.Stamp_End_Date &&
                    <span>
                        <br></br>
                        <b>
                        <span>由</span>
                        <StampDateConverter data={props.data.Stamp_Start_Date}></StampDateConverter>
                        <br></br>
                        <span>至</span>
                        <StampDateConverter data={props.data.Stamp_End_Date}></StampDateConverter>
                        </b>
                    </span>
                }
                {
                    props.data.Stamp_Start_Date == props.data.Stamp_End_Date &&
                    <span>
                        <b><StampDateConverter data={props.data.Stamp_Start_Date}></StampDateConverter></b>
                    </span>
                }
            </div>
                {
                    props.data.Pickup_Location !== 'NA' &&
                    props.data.Event_Url_Name !== '20251106_double_bp' &&
                    <div className="np-effective-info">
                        <span>使用印花門市：<b>{props.data.Pickup_Location}</b></span>
                        {props.data.Event_Url_Name === "20260507_korea10" && (
                            <div dangerouslySetInnerHTML={{__html: shopImage}} />
                        )}
                    </div>
                }
            {
                Difference_In_Days >= 1 &&
                <div className="effective-info">
                    <span>此二維碼將於 {Difference_In_Days} 日後生效</span>
                </div>
            }
            <div>

                <div className="qrcode-logo">
                    <QrcodeDiv stamp_code={props.data.Stamp_Prefix + props.data.Stamp_Code} stamp_icon={props.data.Stamp_QRCode_Icon}/>
                </div>
                {
                    props.data.Pickup_Location !== 'NA' &&
                    props.data.Event_Url_Name !== '20251106_double_bp' &&
                    <div className="qrcode-location">{props.data.Pickup_Location}</div>
                }
                <div className="qrcode-number">
                    <span>{props.data.Stamp_Code}</span>
                </div>
                <div className="screencap-info">
                    <br></br>
                    <span>如有需要，請將本頁截圖!</span>
                    <br></br>
                    <br></br>
                </div>
            </div>

       </>
  );
}

export default PanelRedeemInfo;